import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { CreateModuleCmd } from 'module/command/create-module.cmd';
import { ModuleDocumentOutput } from 'module/model/module-document.output';
import { ModuleOutput } from 'module/model/module.output';
import { ModuleGraphOutput } from 'module/model/page/graph/module-graph.output';
import { CreateDocumentOrganizationModuleApiMutation } from 'module/mutation/create-organization-module.mutation';
import { ModuleApiPort } from 'module/port/module-api.port';
import { FetchModuleGraphsByIdsApiQuery } from 'module/query/fetch-module-graphs-by-ids.query';
import { FetchModulesQuery } from 'module/query/fetch-modules.query';
import { FetchOrganizationModuleByIdApiQuery } from 'module/query/fetch-organization-module-by-id.query';
import { FetchOrganizationModulesByCriteriaApiQuery } from 'module/query/fetch-organization-modules-by-criteria.query';
import { FetchOrganizationModulesByIdsApiQuery } from 'module/query/fetch-organization-modules-by-ids.query';
import { FirstCoachingPlanModuleApiQuery } from 'module/query/first-coaching-plan-module.api-query';
import { UserSessionPort } from 'user/port/user-session.port';

import { ApiAdapter } from '../../common/api.adpater';

@Injectable()
export class ModuleApiAdapter extends ApiAdapter implements ModuleApiPort {
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _httpClient: HttpClient,
		private _fetchModuleGraphsByIdsApiQuery: FetchModuleGraphsByIdsApiQuery,
		private _firstCoachingPlanModuleApiQuery: FirstCoachingPlanModuleApiQuery,
		private _fetchOrganizationModuleByIdApiQuery: FetchOrganizationModuleByIdApiQuery,
		private _fetchOrganizationModulesByIdsApiQuery: FetchOrganizationModulesByIdsApiQuery,
		private _fetchOrganizationModulesByCriteriaApiQuery: FetchOrganizationModulesByCriteriaApiQuery,
		private _createDocumentOrganizationModuleApiMutation: CreateDocumentOrganizationModuleApiMutation
	) {
		super(userSessionPort, translateService);
	}

	public fetchModuleById(id: string): Promise<ModuleOutput> {
		return this.fetch(this._fetchOrganizationModuleByIdApiQuery, {
			id,
		});
	}

	public firstCoachingPlanModule(): Observable<ModuleOutput> {
		return this.fetch$(this._firstCoachingPlanModuleApiQuery);
	}

	public fetchModuleGraphsByIds(ids: string[]): Promise<ModuleGraphOutput[]> {
		return this.fetch(this._fetchModuleGraphsByIdsApiQuery, {
			ids,
		});
	}

	public fetchModules(query: FetchModulesQuery): Promise<ModuleOutput[]> {
		return this.fetch(this._fetchOrganizationModulesByCriteriaApiQuery, {
			input: {
				name: query.name,
				phasesId: query.phasesId,
				moduleType: query.moduleType,
				organizationId: query.organizationId,
			},
		});
	}

	public generateModuleDocumentUrl(
		file: File
	): Observable<ModuleDocumentOutput> {
		const apiUrl = `${environment.contentRestApiBaseUrl}/modules/document`;

		const formData = new FormData();
		formData.append('upload', file, file.name);

		return this._httpClient.post<ModuleDocumentOutput>(apiUrl, formData);
	}

	public createModule(cmd: CreateModuleCmd): Promise<string> {
		return this.mutate(this._createDocumentOrganizationModuleApiMutation, cmd);
	}

	public fetchModulesByIds(ids: string[]): Promise<ModuleOutput[]> {
		return this.fetch(this._fetchOrganizationModulesByIdsApiQuery, {
			ids,
		});
	}
}
